import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import { components } from "@/assets/ts";


const routes: Array<RouteRecordRaw> = [

  // role Superadmin
  {
    path: "/",
    redirect: "/sign-in/ppdb",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/superadmin/dashboard/dashboard.vue"),
      },

      {
        path: "/profile",
        name: "profile",
        component: () => import("@/views/profile.vue"),
      },
      // {
      //   path: "/notification",
      //   name: "notification",
      //   component: () => import("@/views/superadmin/notification/notification.vue"),
      // },

      // router institusi
      {
        path: "/dataregistrasi",
        name: "dataregistrasi",
        component: () => import("@/views/superadmin/dataregistrasi/dataregistrasi.vue"),
      },
      {
        path: "/datainstitusi/:id",
        name: "datainstitusi/update-datainstitusi",
        component: () => import("@/views/superadmin/datainstitusi/edit-datainstitusi.vue"),
      },
      {
        path: "/datainstitusi/detail/:id",
        name: "datainstitusi/detail-datainstitusi",
        component: () => import("@/views/superadmin/datainstitusi/detail-datainstitusi.vue"),
      },

      // router pendaftar
      {
        path: "/datapendaftar",
        name: "datapendaftar",
        component: () => import("@/views/superadmin/datapendaftar/datapendaftar.vue"),
      },
      {
        path: "/datapendaftar/:id",
        name: "datapendaftar/update-datapendaftar",
        component: () => import("@/views/superadmin/datapendaftar/edit-datapendaftar.vue"),
      },
      {
        path: "/datapendaftar/detail/:id",
        name: "datapendaftar/detail-datapendaftar",
        component: () => import("@/views/superadmin/datapendaftar/detail-datapendaftar.vue"),
      },

      // router calon siswa
      {
        path: "/calonsiswa",
        name: "calonsiswa",
        component: () => import("@/views/superadmin/calonsiswa/calonsiswa.vue"),
      },
      {
        path: "/calonsiswa/:id",
        name: "calonsiswa/update-calonsiswa",
        component: () => import("@/views/superadmin/calonsiswa/edit-calonsiswa.vue"),
      },
      {
        path: "/calonsiswa/detail/:id",
        name: "calonsiswa/detail-calonsiswa",
        component: () => import("@/views/superadmin/calonsiswa/detail-calonsiswa.vue"),
      },


      // router invoices
      {
        path: "/invoices",
        name: "invoices",
        component: () => import("@/views/superadmin/invoices/invoices.vue"),
      },
      {
        path: "/invoices/:id",
        name: "invoices/update-invoices",
        component: () => import("@/views/superadmin/invoices/edit-invoices.vue"),
      },
      {
        path: "/invoices/detail/:id",
        name: "invoices/detail-invoices",
        component: () => import("@/views/superadmin/invoices/detail-invoices.vue"),
      },

      // router setting ppdb
      {
        path: "/settingppdb",
        name: "settingppdb",
        component: () => import("@/views/superadmin/settingppdb/settingppdb.vue"),
      },
      {
        path: "/settingppdb/:id",
        name: "settingppdb/update-settingppdb",
        component: () => import("@/views/superadmin/settingppdb/edit-settingppdb.vue"),
      },
      {
        path: "/settingppdb/detail/:id",
        name: "settingppdb/detail-settingppdb",
        component: () => import("@/views/superadmin/settingppdb/detail-settingppdb.vue"),
      },

      // router setting invoices
      {
        path: "/settinginvoices",
        name: "settinginvoices",
        component: () => import("@/views/superadmin/settinginvoices/settinginvoices.vue"),
      },
      {
        path: "/settinginvoices/:id",
        name: "settinginvoices/update-settinginvoices",
        component: () => import("@/views/superadmin/settinginvoices/edit-settinginvoices.vue"),
      },
      {
        path: "/settinginvoices/detail/:id",
        name: "settinginvoices/detail-settinginvoices",
        component: () => import("@/views/superadmin/settinginvoices/detail-settinginvoices.vue"),
      },

      // router setting Institusi
      {
        path: "/settinginstitusi",
        name: "settinginstitusi",
        component: () => import("@/views/superadmin/settinginstitusi/settinginstitusi.vue"),
      },
      {
        path: "/settinginstitusi/:id",
        name: "settinginstitusi/update-settinginstitusi",
        component: () => import("@/views/superadmin/settinginstitusi/edit-settinginstitusi.vue"),
      },
      {
        path: "/settinginstitusi/detail/:id",
        name: "settinginstitusi/detail-settinginstitusi",
        component: () => import("@/views/superadmin/settinginstitusi/detail-settinginstitusi.vue"),
      },

      // router setting tampilan
      {
        path: "/settingtampilan",
        name: "settingtampilan",
        component: () => import("@/views/superadmin/settingtampilan/settingtampilan.vue"),
      },
      {
        path: "/settingtampilan/:id",
        name: "settingtampilan/update-settingtampilan",
        component: () => import("@/views/superadmin/settingtampilan/edit-settingtampilan.vue"),
      },
      {
        path: "/settingtampilan/detail/:id",
        name: "settingtampilan/detail-settingtampilan",
        component: () => import("@/views/superadmin/settingtampilan/detail-settingtampilan.vue"),
      },


      // router Manajemen Pengguna
      {
        path: "/manajemenpengguna",
        name: "manajemenpengguna",
        component: () => import("@/views/superadmin/manajemenpengguna/manajemenpengguna.vue"),
      },

      // router Pemberitahuan
      {
        path: "/pemberitahuan",
        name: "pemberitahuan",
        component: () => import("@/views/superadmin/pemberitahuan/pemberitahuan.vue"),
      },
      {
        path: "/pemberitahuan/detail/:id",
        name: "pemberitahuan/pemberitahuan-detail",
        component: () => import("@/views/superadmin/pemberitahuan/pemberitahuan_detail.vue"),
      },
    ],
  },

  // News
  {
    path: "/news-detail/:title",
    name: "news-detail",
    component: () => import("@/views/NewsDetail.vue"),
  },

  // AUTH
  {
    path: "/",
    component: () => import("@/components/page-layouts/Auth.vue"),
    children: [
      {
        path: "/sign-in/:id",
        name: "sign-in",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignIn.vue"),
      },

      {
        path: "/sign-up",
        name: "sign-up",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignUp.vue"),
      },
      {
        path: "/sign-up-form/:otp/:regId/:email",
        name: "sign-up-form",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignUpForm.vue"),
      },
      {
        path: "/sign-up/input-password",
        name: "sign-up-input-password",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignUpInputPassword.vue"),
      },
      {
        path: "/password-reset",
        name: "password-reset",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/PasswordReset.vue"),
      },
      // {
      //   path: "/reset-password/:token/:email/:id",
      //   name: "reset-password",
      //   component: () =>
      //     import("@/views/crafted/authentication/basic-flow/setuplogin.vue"),
      // },
      {
        path: "/password-reset/:otp/:regId/:email",
        name: "password-reset-create-password",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/PasswordResetCreatePassword.vue"),
      },
    ],
  },
  {
    path: "/reset-password/:token/:email/:id",
    name: "reset-password",
    component: () =>
      import("@/views/crafted/authentication/basic-flow/setuplogin.vue"),
  },
  {
    path: "/registration",
    name: "registration",
    component: () => import("@/views/superadmin/registration/registration.vue"),
  },
  {
    path: "/pre-registration/:id/:grade/:gradeDetail/:year",
    name: "pre-registration",
    component: () => import("@/views/superadmin/registration/pre-registration.vue"),
  },

  {
    path: "/sign-up/check-email",
    name: "check-email",
    component: () =>
      import("@/views/crafted/authentication/basic-flow/ThanksPage.vue"),
  },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/views/crafted/authentication/Error404.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },

  {
    // LandingPage
    path: "/landing-page/:id",
    name: "landing-page",
    component: () => import("@/views/crafted/authentication/LandingPage.vue"),
  },

  // {
  //   // the 404 route, when none of the above matches
  //   path: "/default",
  //   name: "default",
  //   component: () => import("@/views/crafted/authentication/Error404.vue"),
  // },
  // {
  //   path: "/:pathMatch(.*)*",
  //   redirect: "/default",
  // },


];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(() => {
  // reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

export default router;
